import React, { useState } from 'react';
import { Play, Film, X } from 'lucide-react';
import { galleriaVideo } from '../data/mock';
import SocialShare from '../components/SocialShare';

export default function Videos() {
  const [active, setActive] = useState(null);

  return (
    <div className="bg-navy min-h-screen">
      <section className="relative py-24">
        <div className="absolute inset-0 bg-gradient-to-b from-navy-dark to-navy"></div>
        <div className="relative max-w-5xl mx-auto px-4 lg:px-8 text-center">
          <Film size={46} className="text-pink-brand mx-auto mb-4" />
          <h1 className="font-brand text-5xl md:text-6xl font-bold text-white mb-4">Video</h1>
          <div className="w-24 h-1 bg-pink-brand mx-auto rounded"></div>
          <p className="text-white/70 mt-6 max-w-2xl mx-auto">
            Momenti in movimento del Memorial. Partite, premiazioni, spettacoli e tanto altro.
          </p>
          <div className="mt-6 flex justify-center">
            <SocialShare title="Video — Memorial Eugenio Abbro" />
          </div>
        </div>
      </section>

      <section className="pb-20">
        <div className="max-w-6xl mx-auto px-4 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {galleriaVideo.map((v) => (
              <button
                key={v.id}
                onClick={() => setActive(v)}
                className="group glass-card overflow-hidden text-left"
              >
                <div className="relative aspect-video overflow-hidden bg-black">
                  <img src={v.thumbnail} alt={v.titolo} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-navy-dark/90 via-transparent to-transparent"></div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-16 h-16 rounded-full bg-pink-brand flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg animate-pulse-glow">
                      <Play size={26} className="text-white ml-1" fill="white" />
                    </div>
                  </div>
                  <span className="absolute top-3 right-3 bg-pink-brand text-white text-[10px] font-bold px-2 py-1 rounded uppercase tracking-widest">
                    {v.anno}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="text-white font-bold text-base mb-2">{v.titolo}</h3>
                  <p className="text-white/70 text-sm line-clamp-2">{v.descrizione}</p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {active && (
        <div className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4 animate-fade-in" onClick={() => setActive(null)}>
          <button className="absolute top-4 right-4 w-11 h-11 rounded-full bg-pink-brand text-white flex items-center justify-center" aria-label="Chiudi">
            <X size={22} />
          </button>
          <div className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <video src={active.videoUrl} controls autoPlay className="w-full rounded-lg" />
            <div className="mt-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-white">
              <div>
                <div className="text-pink-brand text-xs font-bold uppercase tracking-widest">{active.anno}</div>
                <div className="text-lg font-semibold">{active.titolo}</div>
              </div>
              <SocialShare title={active.titolo} compact />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
